import { createRouter, createWebHistory } from "vue-router";

import { Enums } from "@/helpers/enums";
import { Links } from "@/helpers/links";
import { appData } from "@/helpers/global";
import { Wait } from "@/helpers/web";

import DefaultView from "@/views/DefaultView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import ErrorView from "@/views/ErrorView.vue";

let l = [];
for (const [k, v] of Object.entries(Links)) {
    if (typeof v !== 'function') {
        let callback = function (o) {
            return {
                path: Links.Url(o, o.props),
                name: o.path.replace(/({[0-9]+\}|^[\/]+)/gm, '').replaceAll('/', '-'),
                component: () => import("@/views/" + o.component + ".vue"),
                props: true,
                meta: {
                    title: o.title,
                    theme: o.theme,
                    leftSidebar: o.leftSidebar,
                },
            }
        };
        const callbackItem = function (val) {
            if (val.path) {
                if (val._route == undefined) {
                    l.push(callback(val));
                }
            }
            else {
                for (const [key2, val2] of Object.entries(val)) {
                    callbackItem(val2);
                }
            }
        };
        callbackItem(v);
    }
}

const routes = [

    // Paket almamış öğrenci alt sayfaları
    // Bu route'lar ...l'den ÖNCE olmalı.
    {
        path: "/panel/kocluk",
        name: "candidate-coaching",
        component: () => import("@/views/_partials/student/coaching/CoachingView.vue"),
        props: true,
        meta: { title: "Koçluk", theme: Links.Dashboard.theme, leftSidebar: Links.Dashboard.leftSidebar },
    },
    {
        path: "/panel/ozel-ders",
        name: "candidate-live-education",
        component: () => import("@/views/_partials/student/live-education/ListView.vue"),
        props: true,
        meta: { title: "Özel Ders", theme: Links.Dashboard.theme, leftSidebar: Links.Dashboard.leftSidebar },
    },
    {
        path: "/panel/ozel-ders/planli",
        name: "candidate-live-education-planned",
        component: () => import("@/views/_partials/student/live-education/PlanListView.vue"),
        props: true,
        meta: { title: "Planlı Dersler", theme: Links.Dashboard.theme, leftSidebar: Links.Dashboard.leftSidebar },
    },
    {
        path: "/panel/ozel-ders/gecmis",
        name: "candidate-live-education-history",
        component: () => import("@/views/_partials/student/live-education/HistoryListView.vue"),
        props: true,
        meta: { title: "Geçmiş Dersler", theme: Links.Dashboard.theme, leftSidebar: Links.Dashboard.leftSidebar },
    },
    {
        path: "/panel/ozel-ders/gecmis/:id",
        name: "candidate-live-education-history-detail",
        component: () => import("@/views/_partials/student/live-education/HistoryDetailView.vue"),
        props: true,
        meta: { title: "Ders Detayı", theme: Links.Dashboard.theme, leftSidebar: Links.Dashboard.leftSidebar },
    },
    {
        path: "/panel/soru-havuzu",
        name: "candidate-question-pool",
        component: () => import("@/views/_partials/student/question-pool/QuestionPoolView.vue"),
        props: true,
        meta: { title: "Soru Havuzu", theme: Links.Dashboard.theme, leftSidebar: Links.Dashboard.leftSidebar },
    },
    {
        path: "/panel/kullanim-kilavuzu",
        name: "candidate-guide",
        component: () => import("@/views/_partials/student/guide/GuideView.vue"),
        props: true,
        meta: { title: "Kullanım Kılavuzu", theme: Links.Dashboard.theme, leftSidebar: Links.Dashboard.leftSidebar },
    },
    {
        path: "/panel/hesabim",
        name: "candidate-account",
        component: () => import("@/views/_partials/student/user/ProfileView.vue"),
        props: true,
        meta: { title: "Hesabım", theme: Links.Dashboard.theme, leftSidebar: Links.Dashboard.leftSidebar },
    },

    ...l,
    // Default
    {
        path: "",
        name: "default",
        component: DefaultView,
        props: true,
        meta: {
            title: "App",
            theme: Enums.THEME.EMPTY,
        },
    },
    // External Login
    {
        path: "/auth/callback/:loginType",
        name: "auth-callback",
        component: () => import("@/components/AuthCallback.vue"),
        props: true,
        meta: {
            title: "Giriş",
            theme: Enums.THEME.EMPTY,
        },
    },
    // Payment 3D
    {
        path: "/payment-3d",
        name: "payment-3d",
        component: () => import("@/components/Payment3DCallback.vue"),
        props: true,
        meta: {
            title: "Ödeme Onaylanıyor",
            theme: Enums.THEME.EMPTY,
        },
    },
    //AGORA
    {
        path: "/meeting/:id",
        name: "agoraMeeting",
        component: () => import("@/views/AgoraMeetingView.vue"),
        meta: {
            title: "Görüntülü Görüşme",
            theme: Enums.THEME.EMPTY,
        },
    },
    // 500
    {
        path: "/error",
        name: "error",
        component: ErrorView,
        props: true,
        meta: {
            title: "Bir Hata Oldu!",
            theme: Enums.THEME.EMPTY,
        },
    },
    // 404
    {
        path: "/:pathMatch(.*)*", //path: "/:catchAll(.*)",
        name: "not-found",
        component: NotFoundView,
        props: true,
        meta: {
            title: "Sayfa Bulunamadı!",
            theme: Enums.THEME.EMPTY,
        },
    },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { left: 0, top: 0 };
  },
});
//router.beforeResolve((to, from, next) => {
//    if (to.name) {
//        Wait.Page(true);
//    }
//    next();
//});

router.beforeEach((to, from, next) => {   
    Wait.Page(true);
    /*let modalBackground = document.querySelector('.modal-backdrop')
    if (modalBackground) {
        modalBackground.remove();
    }*/
    next();
});


router.afterEach((to) => {
    Wait.Page(false);
    document.title = "Rehberim Sensin - "  +  to.meta.title;
    appData.page = {}; // temp data kullanimi
    // Complete the animation of the route progress bar.    
});

export default router;